// extracted by mini-css-extract-plugin
module.exports = {"TotalAmount":"TotalAmount_TotalAmount__20r1_"};